import { render } from "./DefFavourite.vue?vue&type=template&id=658a7c64&scoped=true"
import script from "./DefFavourite.vue?vue&type=script&lang=js"
export * from "./DefFavourite.vue?vue&type=script&lang=js"

import "./DefFavourite.vue?vue&type=style&index=0&id=658a7c64&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-658a7c64"]])

export default __exports__